import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import {isLoggedIn} from './services/AuthorizeAdmin';
import {configureStore} from './store';
import {Provider} from "react-redux";
import {BrowserRouter} from 'react-router-dom';

// ReactDOM.render(<App />, document.getElementById('root'));

const renderApp = preloadedState => {
    const store = configureStore(preloadedState);
    window.state = store.getState;
  
    ReactDOM.render(
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>,
      document.getElementById("root")
    );
  };
  
  (async () => renderApp(await isLoggedIn()))();
  
  serviceWorker.unregister();
